import { Alert, Box, Fab } from "@mui/material";
import { createSearchParams, useNavigate } from "react-router-dom";
import { getInspectionEnabledWorkOrderStatues } from "../../../utils/utilityFunctions";
import { hikoGeneratePath } from "@northpowerdev/np-react-utils";

const inspectionStatuses = getInspectionEnabledWorkOrderStatues()

/**
 * 
 * @param {object} {workOrderDetails} E.g.
 * {
 *  "workOrder": {
 *    "workOrderNumber": "00014089",
 *    "workOrderType": "New Connection",
 *    "workType": "Permanent Supply",
 *    "workSubType": null,
 *    "status": "Approved for Connection",
 *    "description": null,
 *    "customerContact": {
 *      "email": "gs.trichon@gmail.com.invalid",
 *      "firstName": "Gregory",
 *      "lastName": "Trichon",
 *      "primaryPhone": "021473434",
 *      "secondaryPhone": "098366785"
 *    },
 *    "networkApprovalFormURL": null,
 *    "networkApprovedParameters": {
 *      "numPhases": null,
 *      "phase": { "red": false, "white": false, "blue": false },
 *      "rippleControllerRequired": false,
 *      "fuseRating": null,
 *      "connectionPoint": "Pole",
 *      "assetNumber": "33491",
 *      "technicalNotes": null,
 *      "dSub": "MC359",
 *      "kVAPhase": "50 kva / 2Ø",
 *      "activeICPs": 8,
 *      "constructionPlan": null,
 *      "maxDemandkW": null,
 *      "maxCapacityAmps": null
 *    },
 *    "proposedPricingCode": null,
 *    "connectionDate": null,
 *    "streetAddress": "93 Atkin Road, Mangawhai, RD2 Kaiwaka,",
 *    "premiseType": "Residential Dwelling",
 *    "icpNo": null,
 *    "salesforceWorkOrderLink": "https://northpower--test.lightning.force.com/lightning/r/WorkOrder/0WO2v000002A7XlGAK/view",
 *    "caseNumber": "00015290"
 *  }
 *}
 * @returns JSX component
 */
export default function IcpInspectionLink({workOrderDetails, inspectionEnabled, sx}) {

    let registryStatus = false
    if(workOrderDetails?.workOrder?.registryStatus === 'new'){
        registryStatus = true
    }

    const navigate = useNavigate()

    const handleSubmitInspection = () => {
        const urlString = '/connect/icp_inspection_by_work_order'
        const params = {icp_number: workOrderDetails.workOrder.icpNo, work_order_id: workOrderDetails.workOrder.workOrderNumber}
        // const path = generatePath(":urlString?:queryString", { urlString, queryString: createSearchParams(params).toString() });
        const path = hikoGeneratePath(urlString, createSearchParams(params).toString())
        navigate(path)

    }

    return (
        <Box sx={sx}>
            <Fab
                sx={{
                    "&.Mui-disabled": {
                    background: "#c5c5c5",
                    color: "#7b7b7b",
                  },
                  my:1}}
                variant="extended"
                color="primary"
                onClick={handleSubmitInspection}
                disabled={!inspectionEnabled || registryStatus}
                
            >
                ICP Inspection Form
            </Fab>
            {
                !inspectionEnabled
                &&
                <Alert severity="info">This ICP is not ready for inspection because its status is {workOrderDetails?.workOrder?.status}. Inspection is enabled for statuses {inspectionStatuses.join(', ')}.</Alert>
            }
        </Box>
    )
}